<template>
    <div class="table-container">
        <div class="table-responsive">
            <table class="table table-striped" @mousemove="moveColumn" @mouseup="endResize">
                <thead>
                <tr>
                    <th v-if="checkbox" class="checkbox-column">
                        <b-form-checkbox
                        v-model="selectAll"
                        :value="true"
                        :unchecked-value="false"
                        v-on:input="toggleAll"></b-form-checkbox>
                    </th>
                    <template v-for="(item, i) in headerData">
                        <th scope="col" draggable @dragstart="startDrag($event, i)" @drop="onDrop($event, i)" @dragover.prevent @dragenter.prevent v-if="orderData.columnsshown[i]" :key="'header_'+i" :style="orderData.columnsizes[i] ? 'min-width: '+orderData.columnsizes[i] : ''" v-b-tooltip.hover :title="(item.tooltip) ? item.tooltip : getName(item.name)">
                            <div>
                                <span :style="item.style">{{getName(item.name)}}</span>
                                <div v-if="item.key && valueComp.sort !== undefined" @click="sortGrid(item.key)">
                                    <img src="../../../assets/img/table-arrow.svg" v-if="valueComp.sort == null || valueComp.sort !== item.key" />
                                    <img src="../../../assets/img/table-arrow.svg" class="active" v-if="valueComp.sort == item.key && valueComp.dir == 'asc'" />
                                    <img style="transform: rotateX(180deg);" src="../../../assets/img/table-arrow.svg" class="active" v-if="valueComp.sort == item.key && valueComp.dir == 'desc'" />
                                </div>
                                <div class="resizer" @mousedown="startResize($event, i)"></div>
                            </div>
                        </th>
                    </template>
                </tr>
                </thead>
                <tbody>
                    <template v-for="(row, i) in gridData">
                        <tr
                            :class="{ 'active': ((checkbox && selectedData[i]) || selectedRow == row) }"
                            :style="customStyle(data[i])"
                            :key="'row_'+i"
                            :ref="'row_'+i"
                            v-on:dblclick="$emit('itemdblclick', data[i], i)"
                            v-on:click="$emit('itemclick', data[i], i); selectedRow = row;">
                            <td v-if="checkbox" class="checkbox-column">
                                <b-form-checkbox
                                v-model="selectedData[i]"
                                :value="true"
                                :unchecked-value="false"
                                v-on:input="emitItemselected(row, i)"></b-form-checkbox>
                            </td>
                            <template v-for="(index, x) in orderData.columns">
                                <td
                                :colspan="(orderData.columns.length-1 == x) ? 2 : false"
                                :key="'col_'+index"
                                v-if="orderData.columnsshown[x] && index != null">
                                    {{row[index]}}
                                    <slot :index="index" :i="i" :item="data[i]" :column="columns[index]"></slot>
                                </td>
                            </template>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="table-menu">
            <span><img v-on:click="showMenu = !showMenu" class="table-filter" src="../../../assets/img/table-filter.svg" /></span>
            <div class="filter-dropdown-main" style="" v-show="showMenu" v-on:mouseleave="showMenu = false;">
                <ul>
                    <li v-if="showExport" v-on:click="downloadCSV"><img src="../../../assets/img/download.svg"><span>{{$t('DOWNLOADCSV')}}</span></li>
                    <li class="submenu" v-if="gridId"><img src="../../../assets/img/list-left.svg"><span>{{$t('GRIDVIEWPROPERTIES')}}</span>
                        <div class="wrapper">
                            <div class="table-dropdown filter-dropdown-sub" >
                                <ul>
                                    <!-- li><b-form-checkbox
                                    v-model="byUser"
                                    :value="true"
                                    :unchecked-value="false"></b-form-checkbox><span> {{$t('SAVEVIEWBYUSER')}}</span></li -->
                                    <li v-on:click="resetComponentUserView"><span>{{$t('RESETUSERVIEW')}}</span></li>
                                </ul>
                            </div>
                        </div>
                    </li>
                    <li class="submenu"><img src="../../../assets/img/list-left.svg"><span>{{$t('SELECTCOLUMNS')}}</span>
                        <div class="wrapper">
                            <div class="table-dropdown filter-dropdown-sub" >
                                <ul>
                                    <li v-for="(header, i) in sortedHeaderData" :key="'header_show_'+i">
                                        <b-form-checkbox
                                        v-model="orderData.columnsshown[header.i]"
                                        :value="true"
                                        :unchecked-value="false"></b-form-checkbox><span> {{getName(header.name)}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <nav class="mt-3 d-flex flex-row form-inline" v-if="totalCount != null">
            <b-pagination class="mr-3 mb-0" align="center" :total-rows="parseInt(totalCount)" v-model="valueComp.currentPage" :per-page="valueComp.limit"></b-pagination>
            <label class="has-float-label mr-2" v-if="showSearch">
                <input type="text" class="form-control search-grid" placeholder=" " v-model="valueComp.query" required />
                <img src="../../../assets/img/icon-color-cancel.svg" class="search-grid-clear" v-on:click="clear()">
                <span>{{$t('SEARCH')}}</span>
            </label>
            <select class="form-control mr-3" v-model="valueComp.limit">
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
                <option :value="200">200</option>
                <option :value="500">500</option>
            </select>
            <div class="ml-auto">
                {{getPagination(valueComp.currentPage, valueComp.limit, totalCount)}}
            </div>
        </nav>
    </div>
</template>

<style lang="scss" scoped>

.table-container {

    position: relative;

    tr {
        &.active {
            background-color: #ccc;
        }
    }

    .table-responsive {

        position: relative;

        table th {

            padding: 0px;
            min-width: 20px;

            &.checkbox-column {
                > div {
                    top: -20px;
                    left: 12px;
                }
            }

            > div {
                display: flex;
                flex-direction: row;
                align-items: center;
                position: relative;

                > span {
                    padding: 0.75rem;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                }

                img {
                    margin: 0px 5px;
                    opacity: 0.5;

                    &.active {
                        opacity: 1;
                    }
                }

                .resizer {
                    height: 100%;
                    width: 3px;
                    cursor: col-resize;
                    position: absolute;
                    right: 0px;
                    border-right: 1px solid #ccc;
                }
            }
        }
    }

    .table-menu {
        position: absolute;
        top: 10px;
        right: 2px;

        > span {
            padding: 5px;
            background-color: #fff;
        }

        .filter-dropdown-main {
            position: absolute;
            top: -14px;
            right: -52px;
            padding: 50px;

            img {
                margin-right: 10px;
            }

            ul {
                list-style: none;
                margin: 0px;
                padding: 0px;
                width: 300px;
                z-index: 5;
                background-color: #fff;
                border: 1px solid #ccc;

                ul {
                    display: none;
                    position: absolute;
                    top: -1px;
                    right: calc(0px + 297px);
                    max-height: 300px;
                    overflow: auto;
                }

                li {
                    position: relative;
                    padding: 0.75rem;
                    border: 1px solid #ccc;
                    &:hover {
                        ul {
                            display: block;
                        }
                    }
                }
            }
        }
    }
}

.has-float-label {
    position: relative;

    &.full-input {
        width: 100%;
    }
}

.has-float-label label,
.has-float-label {
    & span {
    position: absolute;
    font-size: 71%; // cca 10px
    opacity: 1;
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
    top: -0.5em;
    left: 12px;
    z-index: 3;
    line-height: 1;
    background-color: #ffffff;
    padding: 0px 10px 0px 4px;
    color:#737373;
    }
    .form-control:disabled {
        color:rgba(44,44,44, 0.1);
        &+span {
            color:rgba(44,44,44, 0.1);
        }
    }
}

.has-float-label label::after,
.has-float-label > span::after {
    content: " ";
    display: block;
    position: absolute;
    height: 12px;
    top: 50%;
    left: -0.2em;
    right: -0.2em;
    z-index: -1;
}

.has-float-label .form-control::placeholder {
    opacity: 1;
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
}

.has-float-label {

    & .form-control:placeholder-shown:not(:focus)::placeholder {
        opacity: 0;
    }

}

.has-float-label {

    & .form-control:placeholder-shown:not(:focus) + * {
        font-size: 150%;
        top: 0.3em;
    }
}

.has-float-label {

    .form-control:placeholder-shown:not(:focus) + * {
        font-size: 14px;
        top: 12px;
    }

}

.has-float-label .form-control:focus + * {
    color: #004b64;
}

.search-grid {

    // background-color: transparent;

    &:valid {
        background-color: #c8e7f7;

        & ~ .search-grid-clear {
            display: block;
        }
    }
}

.search-grid-clear {
    display: none;
    position: absolute;
    z-index: 1;
    top: 0 !important;
    bottom: 0;
    margin: auto;
    right: .5rem;
    cursor: pointer;
}
</style>

<script>
/* eslint-disable no-underscore-dangle */

import
{
    mapGetters,
}
    from 'vuex';
import Api from '@/api/Globals';

export default {
    name: 'Grid',
    props: {
        value: {
            type: Object,
        },
        data: {
            type: Array,
            value: [],
        },
        checkbox: {
            type: Boolean,
            value: false,
        },
        totalCount: {
            type: Number,
            value: null,
        },
        showSearch: {
            type: Boolean,
            default: true,
        },
        showExport: {
            type: Boolean,
            default: true,
        },
        columns: {
            type: Array,
            value: null,
        },
        gridId: {
            type: String,
            value: null,
        },
        stylingFunc: {
            type: Function,
        },
    },
    data()
    {
        return {
            showMenu: false,
            orderData: {
                columns: null,
                columnsizes: {},
                columnsshown: {},
            },
            resizeData: null,
            byUser: true,
            selectedData: {},
            selectAll: false,
            selectedRow: null,
        };
    },
    created()
    {
        const me = this;

        me.loadGridProp();
    },
    methods: {
        scrollToRow(i)
        {
            const me = this;
            me.$refs[`row_${i}`][0].scrollIntoView();
        },
        clickOnItem(i)
        {
            const me = this;
            me.$refs[`row_${i}`][0].click();
        },
        getSelectedRows()
        {
            const me = this;
            const data = [];

            for (const item of me.data)
            {
                if (me.selectedData[me.data.indexOf(item)])
                {
                    data.push(item);
                }
            }

            return data;
        },
        toggleAll()
        {
            const me = this;

            for (let i = 0; i < me.gridData.length; i += 1)
            {
                me.selectedData[i] = me.selectAll;
            }

            // eslint-disable-next-line prefer-object-spread
            me.selectedData = Object.assign({}, me.selectedData);
        },
        getName(name)
        {
            if (typeof name === 'function')
            {
                return name();
            }
            return name;
        },
        loadGridProp()
        {
            const me = this;
            if (me.gridId)
            {
                if (me.componentProps.byUser && me.componentProps.byUser[me.gridId])
                {
                    me.byUser = true;
                    me.reloadComponentProp(me.componentProps.byUser[me.gridId]);
                }
                else if (me.componentProps.global && me.componentProps.global[me.gridId])
                {
                    me.byUser = false;
                    me.reloadComponentProp(me.componentProps.global[me.gridId]);
                }
            }
        },
        reload()
        {
            const me = this;
            // eslint-disable-next-line prefer-object-spread
            me.valueComp = Object.assign({}, me.valueComp);
        },
        clear()
        {
            const me = this;
            me.valueComp.query = '';
            me.valueComp = { ...me.valueComp };
        },
        reloadComponentProp(props)
        {
            const me = this;
            me.orderData = props;

            if (props.sorting !== undefined)
            {
                let changed = false;
                if (me.valueComp.sort !== props.sorting.sort && props.sorting.sort !== undefined)
                {
                    changed = true;
                    me.valueComp.sort = props.sorting.sort;
                }

                if (me.valueComp.dir !== props.sorting.dir && props.sorting.dir !== undefined)
                {
                    changed = true;
                    me.valueComp.dir = props.sorting.dir;
                }

                if (changed)
                {
                    // eslint-disable-next-line prefer-object-spread
                    me.valueComp = Object.assign({}, me.valueComp);
                }
            }
        },
        sortGrid(key)
        {
            const me = this;

            me.valueComp.sort = key;
            if (me.valueComp.dir === 'asc')
            {
                me.valueComp.dir = 'desc';
            }
            else
            {
                me.valueComp.dir = 'asc';
            }

            // eslint-disable-next-line prefer-object-spread
            me.valueComp = Object.assign({}, me.valueComp);
        },
        startResize(evt, i)
        {
            const me = this;

            evt.preventDefault();

            me.resizeData = {
                curCol: evt.target.parentElement.parentElement,
                startWidth: evt.target.parentElement.parentElement.offsetWidth,
                pageX: evt.pageX,
                i,
            };
        },
        moveColumn(evt)
        {
            const me = this;

            if (!me.resizeData)
            {
                return;
            }

            const diffX = evt.pageX - me.resizeData.pageX;
            const curColWidth = me.resizeData.startWidth;

            me.resizeData.curCol.style.minWidth = `${curColWidth + diffX}px`;
        },
        endResize()
        {
            const me = this;

            if (me.resizeData != null)
            {
                me.$set(me.orderData.columnsizes, me.resizeData.i, me.resizeData.curCol.style.minWidth);
            }

            me.resizeData = null;
        },
        startDrag(evt, item)
        {
            evt.dataTransfer.dropEffect = 'move';
            evt.dataTransfer.effectAllowed = 'move';
            evt.dataTransfer.setData('itemIndex', item);
        },
        onDrop(evt, itemIndex)
        {
            const me = this;

            const dropitem = evt.dataTransfer.getData('itemIndex');

            const dropItemColumnIndex = me.orderData.columns[dropitem];

            me.orderData.columns.splice(dropitem, 1);

            me.orderData.columns.splice(itemIndex, 0, dropItemColumnIndex);
        },
        emitItemselected(row, i)
        {
            const me = this;

            me.$emit('itemselected', me.data[i], me.selectedData[i]);
        },
        async setOrderData()
        {
            const me = this;

            if (me.gridId === null)
            {
                return;
            }

            try
            {
                const data = {
                    ...me.orderData,
                    sorting: {
                        sort: me.valueComp.sort,
                        dir: me.valueComp.dir,
                    },
                };
                await Api.setComponentProp({
                    componentId: me.gridId,
                    byUser: me.byUser,
                    data: JSON.stringify(data),
                });

                if (me.componentProps && me.componentProps.byUser[me.gridId])
                {
                    me.componentProps.byUser[me.gridId] = {
                        ...me.orderData,
                        sorting: {
                            sort: me.valueComp.sort,
                            dir: me.valueComp.dir,
                        },
                    };
                }
            }
            catch (error)
            {
                console.log(error);
            }
        },
        async resetComponentUserView()
        {
            const me = this;
            try
            {
                await Api.resetComponentUserView({
                    componentId: me.gridId,
                });

                if (me.componentProps.byUser[me.gridId])
                {
                    delete (me.componentProps.byUser[me.gridId]);
                }

                me.loadGridProp();
            }
            catch (error)
            {
                console.log(error);
            }
        },
        downloadCSV()
        {
            const me = this;

            const header = [];
            for (const h of me.headerData)
            {
                if (h.key != null)
                {
                    header.push(h.key);
                }
                else
                {
                    header.push('');
                }
            }

            let csvContent = "data:text/csv;charset=utf-8,";


            const gridData = me.gridData.map(item => Object.values(item).join(";").replaceAll("\n", ", "));

            csvContent += [
                header.join(";"),
                ...gridData
            ]
                .join("\n")
                .replace(/(^\[)|(\]$)/gm, "");

            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", "export.csv");
            link.click();
        },
        customStyle(row)
        {
            const me = this;
            if (me.stylingFunc !== undefined)
            {
                return me.stylingFunc(row);
            }

            return {};
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'componentProps',
        ]),
        gridData()
        {
            const me = this;
            const data = [];

            if (me.columns && me.columns.length && me.columns.length > 0)
            {
                for (const row of me.data)
                {
                    const newRow = [];

                    for (const col of me.columns)
                    {
                        if (col.slot)
                        {
                            newRow.push('');
                        }
                        else if (col.handler)
                        {
                            newRow.push(col.handler(row));
                        }
                        else if (col.key)
                        {
                            newRow.push(row[col.key]);
                        }
                        else
                        {
                            newRow.push('');
                        }
                    }
                    data.push(newRow);
                }

                return data;
            }

            for (const row of me.data)
            {
                const newRow = [];
                for (const column of me.headerData)
                {
                    newRow.push(row[column.key]);
                }

                data.push(newRow);
            }

            return data;
        },
        headerData()
        {
            const me = this;
            let columns = [];

            if (me.columns && me.columns.length && me.columns.length > 0)
            {
                for (const col of me.columns)
                {
                    columns.push(col);
                }
            }
            else if (me.data[0] !== undefined)
            {
                columns = Object.keys(me.data[0]).map((key) => ({
                    name: me.$t(key.toUpperCase()),
                    key,
                }));
            }

            if (me.orderData.columns == null || me.orderData.columns.length !== me.columns.length)
            {
                me.orderData.columns = [];
                for (const col of columns)
                {
                    me.orderData.columns.push(columns.indexOf(col));
                    me.$set(me.orderData.columnsizes, columns.indexOf(col), '');
                    me.$set(me.orderData.columnsshown, columns.indexOf(col), (col.shown !== undefined ? col.shown : true));
                }
            }

            const orderedColumns = [];

            for (const order of me.orderData.columns)
            {
                if (columns[order] !== null && columns[order] !== undefined)
                {
                    orderedColumns.push(columns[order]);
                }
            }

            return orderedColumns;
        },
        sortedHeaderData()
        {
            const me = this;

            const data = [...me.headerData];

            for (const item of data)
            {
                item.i = me.headerData.indexOf(item);
            }

            return data.sort((a, b) =>
            {
                if (a.name > b.name)
                {
                    return 1;
                }
                return -1;
            });
        },
        valueComp:
        {
            get()
            {
                const me = this;
                return me.value;
            },
            set(val)
            {
                const me = this;

                me.$emit('input', val);
            },
        },
    },
    watch: {
        gridData:
        {
            handler()
            {
                const me = this;

                for (const row of me.data)
                {
                    me.selectedData[me.data.indexOf(row)] = false;
                }

                // eslint-disable-next-line prefer-object-spread
                me.selectedData = Object.assign({}, me.selectedData);
            },
        },
        'valueComp.sort'()
        {
            const me = this;
            me.setOrderData();
        },
        'valueComp.dir'()
        {
            const me = this;
            me.setOrderData();
        },
        /*
        'valueComp.currentPage'(val)
        {
            // console.log(val);
        },
        */
        orderData:
        {
            deep: true,
            async handler()
            {
                const me = this;
                me.setOrderData();
            },
        },
    },
};
</script>
